import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Tabs,
  Spin,
  DatePicker,
  Modal,
  Form,
  Checkbox,
  Tooltip,
  Input,
  Select,
  notification,
  Radio,
  AutoComplete,
} from "antd";
import Config from "../../config";
import axios from "axios";
//import PlusIcon from "./PlusIcon.png";
import dayjs from "dayjs";
//import CrossIcon from "./Cross.svg";
//import AddIncident from "./AddIncident.svg";
import moment from "moment";
import DeleteImg from "../../components/images/DeleteImg.svg";
import AddIconBlue from "../images/AddIconBlue.svg";
import AddAttachment from "./CreateTicket/AddAttachmentModel/AddAttachment";
//import "./Incidents.css";
//import Message from "./Message.svg";
//import AddNew from "./AddNew.svg";

export default class ActivityLog extends Component {
  state = {
    activityLogArray: [],
    months: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    isModalVisible: false,
    showDocument: false,
    dataFromChild: "",
  };

  componentDidMount() {
    this.fetchAcivityLogDetails();
  }

  handleDataFromChild = (data) => {
    this.setState({ dataFromChild: data });
  };

  fetchAcivityLogDetails = () => {
    const ticketID = 10;
    const token = "generated_token"; // Replace 'generated_token' with the actual generated token

    const requestData = {
      TicketID: this.props.TicketID,
      // "Roles": ["Plan Admin"]
      Roles: sessionStorage.getItem("rolename").split(','),
    };
    // axios
    //   .post(`${Config.Ticket}/GetActivityLogByTicketID`, {
    //     headers: {
    //         'Content-Type': 'application/json',
    //       Authorization: sessionStorage.getItem("access_token"),
    //     },
    //     body: JSON.stringify(requestData)
    //   })
    fetch(`${Config.Ticket}/GetActivityLogByTicketID`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionStorage.getItem("access_token"),
      },
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        // Handle the response data here
        console.log(data);
        this.setState({
          activityLogArray: data,
        });
      })
      .catch((error) => {
        // Handle errors here
        console.error(error);
      });
  };
  downloadAttachment = () => {
    this.setState({
      isModalVisible: true,
    });
  };
  openModal = () => {
    this.setState({
      showDocument: true,
    });
  };
  handleCancel = () => {
    this.setState({
      isModalVisible: false,
    });
  };
  render() {
    return (
      // <div>Attachment</div>
      <div>
        <div className="">
          <div>
            {this.state.activityLogArray.length === 0 && (
              <Row
                style={{ marginTop: "35vh" }}
                justify="center"
                align="center"
                type="flex"
              >
                <Col style={{ textAlign: "center" }}>
                  <Spin size="large" />
                  <div className="search-sreen-text">Loading Data...</div>
                </Col>
              </Row>
            )}
            {this.state.activityLogArray.length != 0 && (
              <div>
                <div className="fieldBackground">
                  <div className="incidentFlex addBorder">
                    <div className="addIncident">
                      Total Logs :{" "}
                      {this.state.activityLogArray.length < 10
                        ? "0" + this.state.activityLogArray.length
                        : this.state.activityLogArray.length}
                    </div>
                  </div>
                  <div
                    className="attachmentTableDiv tableMarginLeftPadding"
                    style={{ marginTop: "0px" }}
                  >
                    <table
                      className="attachmentTable incidentdummyTable1"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Added On</th>
                          <th>Added By</th>
                          <th>Action</th>
                          <th>Outcome</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody className="tableBody">
                        {this.state.activityLogArray.length != 0 &&
                          this.state.activityLogArray.map((item, index) => {
                            if (index <= 8) {
                              var serialNumber = "0" + (index + 1);
                            } else {
                              var serialNumber = index + 1;
                            }

                            const formatDate = (dateTimeString) => {
                              const options = {
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric',
                                hour: 'numeric',
                                minute: 'numeric',
                                hour12: false,
                              };
                            
                              const date = new Date(dateTimeString);
                              return new Intl.DateTimeFormat('en-US', options).format(date);
                            };
                            return (
                              <tr>
                                <td>{serialNumber}</td>
                                <td>
                                  {formatDate(item.CreatedDate)}
                                </td>
                                <Tooltip title={item.CreatedByUsername}>
                                <td>{item.CreatedByUsername}</td>
                                </Tooltip>
                                <Tooltip title={item.Action}>
                                <td>{item.Action}</td>
                                </Tooltip>
                                <Tooltip title={item.Outcome}>
                                  <td>{item.Outcome}</td>
                                </Tooltip>
                                {/* <td>
                                    <img
                                      src={DeleteImg}
                                      onClick={() =>
                                        this.showModal(item, "attachments")
                                      }
                                      style={{
                                        width: "11px",
                                        height: "15px",
                                        cursor: "pointer",
                                      }}
                                      alt="delete"
                                    />
                                  </td> */}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
